<template>
  <b-modal id="doc-quick-view-modal" scrollable ref="docPreviewModal" size="lg" hide-footer @hidden="resetModalValues">
    <div v-if="previewDocument">
      <iframe ref="dframe" :src="previewDocument" :height="windowHeight" width="100%" allowtransparency="true" frameborder="0"></iframe>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "document-preview-modal",
  props: ["previewDocument"],
  data() {
    return {
      windowHeight: window.innerHeight - 72
    };
  },
  methods: {
    show() {
      this.$refs.docPreviewModal.show();
    },
    hide() {
      this.$refs.docPreviewModal.hide();
    },
    resetModalValues() {
      this.$emit("resetPreviewDocument");
    },
    onResize() {
      this.windowHeight = window.innerHeight - 72;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  #doc-quick-view-modal {
    .modal-dialog {
      min-width: 800px !important;
      vertical-align: top;
      margin: 10px auto;
    }
  }
}

#doc-quick-view-modal {
  .modal-content {
    .modal-header {
      border-bottom: 0;
      padding-top: 3px;
      padding-bottom: 5px;
      .close {
        margin: 0;
        padding: 0;
      }
    }
  }

  .modal-body {
    padding-top: 0;
    /*         padding-left: 30px;
        padding-right: 30px; */
  }
}
</style>
